module.exports = __webpack_public_path__ + "img/hummer.bdf4e719.svg";